import React from 'react';
import { makeStyles, rgba } from 'design-system/styles';
import { getLabelColorPalette, IColorMap } from './namedEntityRecognitionLabels';
import { INamedEntityRecognitionAnnotation } from './namedEntityRecognitionAnnotations';
import classNames from 'classnames';

interface INERLinkTextProps {
  sourceAnnotation: INamedEntityRecognitionAnnotation;
  targetAnnotation: INamedEntityRecognitionAnnotation;
  displayName?: string;
  labelColormap: IColorMap;
  className?: string;
}

const NERLinkText: React.FC<INERLinkTextProps> = ({
  sourceAnnotation,
  targetAnnotation,
  displayName,
  labelColormap,
  className,
}) => {
  const classes = useNERLinkTextClasses({
    sourceLabelColor: getLabelColorPalette(sourceAnnotation.labelId, labelColormap)
      .labelUnderlineHoverred,
    targetLabelColor: getLabelColorPalette(targetAnnotation.labelId, labelColormap)
      .labelUnderlineHoverred,
  });

  if (displayName) {
    return (
      <span className={classNames(classes.text, className)}>
        <span
          className={classNames(
            classes.annotation,
            classes.annotationInPhrase,
            classes.sourceAnnotation,
          )}
        >
          {sourceAnnotation.text}
        </span>
        <span className={classes.displayPhrase}>{displayName}</span>
        <span
          className={classNames(
            classes.annotation,
            classes.annotationInPhrase,
            classes.targetAnnotation,
          )}
        >
          {targetAnnotation.text}
        </span>
      </span>
    );
  } else {
    return (
      <span
        className={classNames(
          classes.annotation,
          classes.annotationBySelf,
          classes.targetAnnotation,
          className,
        )}
      >
        {targetAnnotation.text}
      </span>
    );
  }
};

const useNERLinkTextClasses = makeStyles<{ sourceLabelColor: string; targetLabelColor: string }>({
  text: {
    display: 'flex',
    alignItems: 'baseline',
  },
  annotation: {
    color: 'black',
    fontSize: '14px',
    fontWeight: 400,
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  annotationBySelf: {
    maxWidth: 150,
  },
  annotationInPhrase: {
    maxWidth: 60,
  },
  sourceAnnotation: ({ sourceLabelColor }: { sourceLabelColor: string }) => ({
    borderBottomColor: sourceLabelColor,
  }),
  targetAnnotation: ({ targetLabelColor }: { targetLabelColor: string }) => ({
    borderBottomColor: targetLabelColor,
  }),
  displayPhrase: {
    color: rgba('#000', 0.6),
    fontSize: '14px',
    fontStyle: 'italic',
    marginInline: '6px',
  },
});

export default NERLinkText;
